<template>
	<div class="ReContactMessangersTemplate">
		<div class="template-text p-2 mb-2" ref="text_template" v-on:focus="$event.target.select()">{{text}}</div>
		<div class="messangers">
			<template v-for="(dopContact, dc_index) in contacts">
				<p class="description d-inline-flex" :key="dc_index" v-if="dopContact.contact_group!='social' && dopContact.contact_group!='phone' && dopContact.contact_group!='messanger' && text==''" >
					
					<span v-if="dopContact.contact_group!='messanger'" class="d-inline-flex col-md-4 pl-0 align-items-center">{{strContactType(dopContact)}}</span> 
					<a :href="hrefContact(dopContact)" class="d-inline-flex col-md-7 px-0  align-items-center" 
						:class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
						<i v-if="dopContact.contact_group=='email'" class="d-inline-flex tim-icons icon-email-85"></i>
						<i v-if="dopContact.contact_group=='phone'" class="d-inline-flex tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
						<i v-if="dopContact.contact_group=='web'" class="d-inline-flex tim-icons icon-link-72"></i>
						<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}} </span>
						<span v-if="dopContact.contact_group!='phone'" style="max-width: 470px;
									overflow: hidden;
									white-space: nowrap;"
						>{{dopContact.contact_value}}</span>
					</a>					
				</p>

				<div class="d-inline-flex mb-1" :key="`m-${dc_index}`" v-else-if="dopContact.contact_group=='messanger'" style="width:fit-content;">
					<a :href="hrefContact(dopContact)" @click="copyText" target="_blank" class="btn btn-icon btn-simple mr-2"
					:class="[{'btn-success':dopContact.contact_type=='41'},{'btn-info':dopContact.contact_type=='42'},{'btn-primary':(dopContact.contact_type!='42' || dopContact.contact_type!='41')}]"
					>
						<i v-if="dopContact.contact_type=='40'" class="d-inline-flex messicon messicon-telegram"></i>
						<i v-if="dopContact.contact_type=='41'" class="d-inline-flex messicon messicon-whatsapp"></i>
						<i v-if="dopContact.contact_type=='42'" class="d-inline-flex messicon messicon-viber"></i>
						<i v-if="dopContact.contact_type=='43'" class="d-inline-flex messicon messicon-skype"></i>
					</a>

				</div>					
			
				<p class="description row" :key="`p-${dc_index}`" v-else-if="dopContact.contact_group=='phone' && masCalls.length==0 && text==''">
					<span class="d-inline-flex col-md-4 align-items-center">{{strContactType(dopContact)}}</span> 
					<a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-flex col-md-7 align-items-center" 
						:class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
						<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
						<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}}</span>
						<span v-else>{{dopContact.contact_value}}</span>
					</a>
				</p>
				
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ReContactMessangersTemplate',
		components: {

		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			text: String,
			contacts: {
				type:Array,
				default: function(){return [];},
			},
			masCalls: {
				type:Array,
				default: function(){return [];},
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			hrefContact(dopContact){
				//console.log(contactType);
				let strHref = '#';
				switch (dopContact.contact_type) {
					case '11'://email
						strHref = 'mailto:'+dopContact.contact_value;
						break;
					case '41'://watsapp
						strHref = 'whatsapp://send?phone=+'+dopContact.concact_phone_INT;
						break;
					case '40'://telegram
						// strHref = 'tg://resolve?domain=+'+dopContact.concact_phone_INT;
						strHref = 'http://t.me/+'+dopContact.concact_phone_INT;
						// strHref = 't.me/'+dopContact.contact_value;
						// https://t.me/
						break;
					case '42'://viber
						strHref = 'viber://chat?number=+'+dopContact.concact_phone_INT;
						break;
					case '43'://skype
						strHref = 'skype:'+dopContact.contact_value+'?call';
						break;
					case '21'://web
						strHref = dopContact.contact_value;
						break;
				}
				return strHref;
			},
			strContactType: function(objContact){
				//console.log('strContactType',objContact.contact_group,objContact.contact_type,this.$GVO.cats.CONTACTS_TYPES);
				return this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types[objContact.contact_type];
			},
			Call(strPhone,obj_type,obj_id){
				// console.log(strPhone,obj_type,obj_id);
				//this.$GVO.Call(strPhone,obj_type,obj_id);
			},
			selectText(element) {
				let range;
				if (document.selection) {
					// IE
					range = document.body.createTextRange();
					range.moveToElementText(element);
					range.select();
				} else if (window.getSelection) {
					range = document.createRange();
					range.selectNode(element);
					window.getSelection().removeAllRanges();
					window.getSelection().addRange(range);
				}
			},
			copyText() {
				this.$refs.text_template.focus();
				this.selectText(this.$refs.text_template);
				document.execCommand('copy');

				/*
				//let coppiedTxt = this.$refs.text_template.innerText; // this.text ???
				//console.log(coppiedTxt);
				
				// if (typeof navigator != "undefined" && typeof navigator.clipboard != "undefined" && navigator.permissions != "undefined"){
				// 	console.log('navigator.permissions != "undefined"');
				// }

				navigator.clipboard.write(coppiedTxt).then(
					() => {
						console.log("Copied to clipboard");
					},
					() => {
						console.log("NOT Copied to clipboard");
					}
				);
				*/
				
				//clipboard.writeText(this.text);
			}
		},
	}
</script>
<style scoped>
	.ReContactMessangersTemplate >>> .messicon {
		width: 18px;
		height: 18px;
		display: inline-block;
		margin-top: 8px;
	}
	.ReContactMessangersTemplate >>> .messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.ReContactMessangersTemplate >>> .messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.ReContactMessangersTemplate >>> .messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.ReContactMessangersTemplate >>> .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; }
	.template-text {border: 1px solid #01B0E0; border-radius: 0.2857rem;white-space: pre-wrap;}
</style>
